import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
//获得用户信息
function getUserInfo(state) {
    if (state.userInfo) return state.userInfo;
    let userInfo = localStorage.getItem(keys.USER);
    if (userInfo) {
        state.userInfo = JSON.parse(userInfo);
    }
    return state.userInfo;
}
const keys = { USER: 'user' }//保存在本地的key
const state = {
    userInfo:"",
    busStore:null,
    region:[],
    sysConfig:{},
    isPaly:false
  }
  const getters = {
    //getUserInfo: state => state.userInfo,
    getUserInfo: (state) => () => {
        getUserInfo(state);
        return state.userInfo;
    },
    getToken: (state) => () => {
        getUserInfo(state);
        if (state.userInfo) {
            return 'Bearer ' + state.userInfo.accessToken;
        }
        return '';
    },
    getRefreshToken: (state) => () => {
      getUserInfo(state);
      if (state.userInfo) {
          return state.userInfo.refreshToken;
      }
      return '';
  },
    isLogin: (state) => () => {
        if (getUserInfo(state)) {
            return true;
        }
        return false;
    },
    getSysConfig:state=>state.sysConfig,
    getIsPaly:state=>state.isPaly,
    getRegion:state=>state.region,
    Language: (state) => () =>
    {
      return sessionStorage.getItem('changeLang') ? sessionStorage.getItem('changeLang') : 'en-US';
    },
    getBusStore:state=>state.busStore,
  }
  const mutations = {
    sebusStore(state,data)
    {
      state.busStore=data
    },
    setLanguage: (state, data) => {

      state.Language = data;
      console.log(state.Language)
      sessionStorage.setItem('changeLang', data);
    },
    setRegion(state,data)
    {
      state.region=data
    },
    setIsPaly(state,data)
    {
      state.isPaly=data
    },
    setConfig(state,data)
    {
      state.sysConfig=data
    },
    setUserInfo (state, data) {
      state.userInfo = data
      localStorage.setItem(keys.USER, JSON.stringify(data));
    },
    clearUserInfo(state) {
        state.userInfo=null;
        localStorage.removeItem(keys.USER);
    },
    //this.$store.commit('mutations方法名', 值),只能接收一个参数
    //更新json对象，针对键值修改，例如：this.$store.commit('updataUser',{username:"优加"});json对象中的username的值改为优加
    updataUser(state,data)
    {
      var jsonObj=getUserInfo(state);
      for (var key in data) {
        if (data.hasOwnProperty(key) && (jsonObj.hasOwnProperty(key))) {
          jsonObj[key] = data[key];
        }
      }
      localStorage.setItem(keys.USER, JSON.stringify(jsonObj));//写入在本地
    }
  

  }
  export default new Vuex.Store({
    state,
    getters,
    mutations
  })


// WEBPACK FOOTER //
// ./src/store/index.js